module.exports = __webpack_public_path__ + "static/media/lines-three-colored.dc69a6dd.png";